module.exports = __webpack_public_path__ + "static/img/patho-ceruminolite-BpIaeh-b.2eb300ee.png";